import React from 'react';
import ReactDOM from 'react-dom';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import { generateQueryClient } from 'src/queryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthenticationProvider } from 'src/components/authentication';
import { App } from './components/App';
import { AppInitWrapper } from './components/AppInitWrapper';

ReactDOM.render(
  <React.StrictMode>
    <StencilProvider>
      <AppInitWrapper>
        <QueryClientProvider client={generateQueryClient()}>
          <React.Suspense fallback={<Spinner size={SpinnerSize.Large} />}>
            <AuthenticationProvider>
              <App />
            </AuthenticationProvider>
          </React.Suspense>
        </QueryClientProvider>
      </AppInitWrapper>
    </StencilProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
